import { LocationFragment, LocationGroupFragment, ProductGroupFragment } from '@occc/graphql';

import { GroupAudienceTargetingAttributesByType, isNotUndefined } from './utils';

export const prepareAudiencePurchaseAttributes = (
  attributes: GroupAudienceTargetingAttributesByType,
  productGroups: ProductGroupFragment[],
  locations?: LocationFragment[],
  locationGroups?: LocationGroupFragment[],
) => {
  if (!productGroups?.length) {
    return [];
  }

  return attributes.purchases.map((purchase) => {
    const mapIdToProductGroup = (productGroupId: string) => {
      return productGroups.find((productGroup) => productGroup.id === productGroupId);
    };

    const productGroupsForThisPurchase = (purchase.productGroupIds || [])
      .map(mapIdToProductGroup)
      .filter(isNotUndefined);

    const mapUuidToLocation = (locationUuid: string) => {
      return locations?.find((location) => location.uuid === locationUuid);
    };

    const mapUuidToLocationGroup = (locationGroupUuid: string) => {
      return locationGroups?.find((locationGroup) => locationGroup.uuid === locationGroupUuid);
    };

    const locationsForThisPurchase = (purchase.purchasedLocationUuids || [])
      .map(mapUuidToLocation)
      .filter(isNotUndefined);

    const locationGroupsForThisPurchase = (purchase.purchasedLocationGroupUuids || [])
      .map(mapUuidToLocationGroup)
      .filter(isNotUndefined);

    return {
      ...purchase,
      productGroups: productGroupsForThisPurchase,
      locations: locationsForThisPurchase,
      locationGroups: locationGroupsForThisPurchase,
    };
  });
};
